import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

/**
 * v0.4 追加要件⑬ (D-395/D-410): 習熟度マスタが実質「未整備」(0件または1件) のテナントかどうかを
 * 実データから判定する共通フック。フラグやテナント設定は持たない (§6-0 原則3: 「そのテナントの現行
 * skill_levels が1件以下」という実データ由来の判定にする)。
 *
 * 適用先は5画面 (①スキルタブ ②習熟度タブ ③人材像タブ ④社員詳細のスキルタブ ⑤条件エディタ)。
 * 判定をここに集約することで §8-55 型の二重定義を避ける。
 *
 * 設計: docs/design/v04-simple-staffing-mode-detail.md §8-4 (D-410)
 */
export type SkillLevelOption = { skill_level_id: string; code: string; label: string; sort_order: number };

export function useSkillLevelSimplified() {
  const { data: skillLevels = [], isLoading } = useQuery<SkillLevelOption[]>({
    queryKey: ['skill-levels'],
    queryFn: () => apiFetch<SkillLevelOption[]>('/masters/skill-levels'),
    staleTime: 5 * 60 * 1000,
  });
  // ⚠️ design-expert指摘 (MEDIUM): 取得中は skillLevels=[] の既定値により isSimplified が常に
  // true になり、複数段階を運用する既存テナントでデータ到着後に「簡略→フル」へ突然切り替わる
  // レイアウトシフトが起きる。取得中は isSimplified=false (フル表示) に倒し、実データが
  // 揃ってから初めて簡略判定を確定させる (逆方向のちらつき — フル→簡略 — は要素が消えるだけで
  // 突然出現するより違和感が小さい)。
  const isSimplified = !isLoading && skillLevels.length <= 1;
  const defaultLevelId = skillLevels[0]?.skill_level_id;
  return { isSimplified, defaultLevelId, skillLevels, isLoading };
}
